import { mainApi } from '../index';
import type { AffiliateLink, TransferLinkPayload } from '@/features/affiliate-links/types/affiliateLinks.types';

/**
 * Fetch user's affiliate links
 */
export async function fetchMyAffiliateLinks(signal?: AbortSignal): Promise<AffiliateLink[]> {
    const { data } = await mainApi.get<AffiliateLink[]>('v1/resell_rights/links', { signal });
    return data;
}

/**
 * Complete affiliate link setup by agreeing to terms and conditions
 */
export async function agreeToAffiliateTerms(linkId: number): Promise<void> {
    await mainApi.post(`/v1/resell_rights/resellers/${linkId}/agreed-terms-and-condition`);
}

/**
 * Transfer affiliate link to another user
 */
export async function transferAffiliateLink(payload: TransferLinkPayload): Promise<void> {
    await mainApi.post('/v1/resell-rights/transfer-affiliate-link', {
        resell_rights_id: payload.linkId,
        email: payload.email,
        username: payload.username,
    });
}
